/*
 *
 * CourseDetailMobile constants
 *
 */

export const FLUSH_STATE = 'app/CourseDetailMobile/FLUSH_STATE';

export const LOAD_COURSE = 'app/CourseDetailMobile/LOAD_COURSE';
export const LOAD_COURSE_SUCCESS =
  'app/CourseDetailMobile/LOAD_COURSE_SUCCESS';
export const LOAD_COURSE_ERROR = 'app/CourseDetailMobile/LOAD_COURSE_ERROR';

export const UPDATE_COURSE = 'app/CourseDetailMobile/UPDATE_COURSE';
export const UPDATE_COURSE_SUCCESS =
  'app/CourseDetailMobile/UPDATE_COURSE_SUCCESS';
export const UPDATE_COURSE_ERROR = 'app/CourseDetailMobile/UPDATE_COURSE_ERROR';
